import { Component } from '@angular/core';

@Component({
  selector: 'lis-pricelists-detail',
  imports: [],
  templateUrl: './pricelists-detail.html',
  styleUrl: './pricelists-detail.scss',
})
export class PricelistsDetail {

}
